<!-- Part of the SPARKL educational activity system, Copyright 2020 by Pepper Williams -->
<template><div><k-dialog v-model="dialog_open" max-width="1200" persistent scrollable content-class="k-collection-editor-dialog">
<k-card>
<k-card-title class="pt-2" style="border-bottom:1px solid #999">
	<b v-html="dialog_title"></b>
	<k-spacer></k-spacer>
	<k-btn v-if="collection_type=='my'" color="pink darken-3" dark small class="mr-8 k-tight-btn" @click="additional_my_options_showing=!additional_my_options_showing"><k-icon small class="mr-2">fas fa-gear</k-icon>{{additional_my_options_showing?'Hide':'Show'}} Additional Options</k-btn>
	<k-menu bottom left><template v-slot:activator="{on}"><k-btn v-show="additional_my_options_showing&&learning_progression.lp_id>0" v-on="on" class="mr-2" color="secondary">Advanced Editor Tools</k-btn></template>
		<k-list min-width="250">
			<!-- <k-list-item @click="import_terms_btn_clicked"><k-list-item-title>Import Terms and Units from MS Word</k-list-item-title></k-list-item> -->
			<k-list-item @click="collection_import_from_case"><k-list-item-title>Import Units and Content from CASE Framework</k-list-item-title></k-list-item>
			<k-list-item @click="import_cc_btn_clicked"><k-list-item-title>Import Resources from Thin Common Cartridge</k-list-item-title></k-list-item>
			<k-list-item v-if="published_asset_counts.unpublished" @click="$emit('publish_all_unpublished')"><k-list-item-title>Publish All Assets</k-list-item-title></k-list-item>
			<k-list-item v-if="published_asset_counts.published" @click="unpublish_all"><k-list-item-title>Unpublish All Assets</k-list-item-title></k-list-item>
			<k-list-item v-if="user_info.email.includes('commongoodlt')" @click="register_sparkls_to_cureum"><k-list-item-title>Register Sparkl activities to this Cureum instance (CGLT only)</k-list-item-title></k-list-item>
			<k-list-item v-if="site_config.show_course_alt_cureum_btn=='yes' && collection_type=='course'" @click="update_state_course_code"><k-list-item-title>Set or update the State Course Code for this collection</k-list-item-title></k-list-item>
		</k-list>
	</k-menu>
	<k-btn color="secondary" @click="cancel_editor" class="mr-2"><k-icon small class="mr-2">fas fa-times</k-icon> Cancel</k-btn>
	<k-btn color="primary" @click="save_edits"><k-icon small class="mr-2">fas fa-check</k-icon> Save</k-btn>
</k-card-title>
<k-card-text class="ma-0 pt-0 pb-3 px-3" style="font-size:16px; color:#000;">

<div class="k-lp-editor-wrapper">
	<div class="k-lp-editor-top-data">
		<div class="d-flex mb-4 align-center">
			<k-text-field background-color="#fff" style="font-weight:bold" hide-details outlined :label="collection_type=='course'?'Course Title (required)':'Collection Title (required)'" v-model="title" @change="title_changed"></k-text-field>
			<k-text-field v-if="collection_type=='course'" background-color="#fff" style="font-weight:bold;max-width:250px" class="ml-4" hide-details outlined label="Course Code" v-model="course_code"></k-text-field>
			<!-- <k-text-field v-if="is_repo_or_pd" background-color="#fff" style="max-width:320px" class="ml-4" hide-details outlined label="Repository Category" v-model="repo_category"></k-text-field> -->
			<div v-if="is_repo_or_pd || is_my" class="d-flex">
				<k-select v-model="repo_category" :items="repo_dropdown" @change="repo_category_changed" label="Collection Category" outlined background-color="#fff" hide-details class="k-lp-subject-menu ml-2" :menu-props="{maxHeight:700}"></k-select>
			</div>
		</div>

		<div v-if="additional_my_options_showing" class="mb-2"><b>Grade range, subject, and other collection metadata:</b><span v-if="collection_type!='course'" class="ml-2">(optional)</span></div>
		<div v-if="additional_my_options_showing" class="d-flex mb-4">
			<k-select v-model="grade_low" :items="grades_low" @change="grade_low_changed" label="Grade Low" dense outlined background-color="#fff" hide-details class="k-lp-grade-menu" :menu-props="{maxHeight:700}"></k-select>
			<k-select v-model="grade_high" :items="grades_high" @change="grade_high_changed" label="Grade High" dense outlined background-color="#fff" hide-details class="k-lp-grade-menu ml-2" :menu-props="{maxHeight:700}"></k-select>
			<k-select v-model="subject" :items="subjects" label="Subject" dense outlined background-color="#fff" hide-details class="k-lp-subject-menu ml-2" :menu-props="{maxHeight:700}" @change="subject_changed"></k-select>
			<span style="margin-left: 10px"><ColorPicker :color="color" :title="title" :subject="subject" @update_color="update_color"/></span>
			<!-- "my" collections are always active -->
			<k-checkbox v-if="collection_type!='my'" class="ml-4 pt-0 mt-2" :label="'Active'" v-model="active" hide-details></k-checkbox>
			<k-checkbox v-if="is_repo" class="ml-4 pt-0 mt-2" :label="'Subscription Only'" v-model="subscription_only" hide-details></k-checkbox>
		</div>

		<div v-if="additional_my_options_showing" class="d-flex mb-4 align-start">
			<div style="flex:1 0 50%">
				<div class="mb-1"><b>“Home” Standards Framework:</b><span class="ml-2">(optional)</span></div>
				<div v-if="!changing_subject_case_title" class="d-flex mr-4">
					<k-btn small class="mr-2" color="primary" @click="changing_subject_case_title=true">Change</k-btn>
					<div v-html="subject_case_title" class="k-v-align"></div>
				</div>
				<div v-if="changing_subject_case_title" class="d-flex">
					<k-select v-model="subject_case_identifier" :items="subject_frameworks" label="Subject Framework" dense outlined background-color="#fff" hide-details class="k-lp-subject-menu" @change="course_case_identifier = ''"></k-select>
					<k-btn small class="k-v-align ml-2" color="primary" @click="changing_subject_case_title=false">Done</k-btn>
				</div>
			</div>
			<div style="flex:1 0 50%">
				<div class="mb-1"><b>Home “Branch” in Standards Framework:</b> (optional)</div>
				<div class="d-flex">
					<k-btn class="mr-2" color="primary" small @click="choose_course_case_identifier">{{course_case_identifier ? 'Change' : 'Choose'}}</k-btn>
					<k-btn v-if="course_case_identifier" class="mr-2" color="tertiary" small @click="clear_course_case_identifier">Clear</k-btn>
					<div v-if="course_case_title" v-html="course_case_title" class="k-v-align"></div>
				</div>
			</div>
		</div>

		<!-- don't show unit description editor if a unit_plan has been set -->
		<div v-if="!(collection_plan&&collection_plan.is_set())" class="mb-4"><div class="mb-1"><b>Content Collection Description:</b><span class="ml-2">(optional)</span></div>
			<div class="k-collection-description-froala-wrapper-wrapper"><froala-wrapper :config="editor_config('')" v-model="description" /></div>
		</div>

		<div v-if="collection_plan_showing" class="mb-2">
			<CollectionPlanEdit
				plan_type='course',
				:editor_collection_plan.sync='collection_plan'
			/>
		</div>

		<div v-if="resource_collection_ids.length > 0" class="mt-3 text-center">
			<k-btn v-for="(resource_collection_id, i) in resource_collection_ids" :key="i" class="ma-1" style="letter-spacing:0; text-transform:none;" color="secondary" small @click="clear_resource_collection(i)">Clear Resource Collection “{{resource_collection_ids[i]}}” from LP</k-btn>
		</div>
	</div>

	<div v-if="additional_my_options_showing" class="k-lp-editor-terms">
		<div class="d-flex align-center">
			<h3 class="ml-3">Unit Arrangement:</h3>
			<div class="ml-4">
				<k-btn-toggle dense active-class="k-toggle-btn-active-class blue darken-4" class="k-toggle-btn" v-model="lp_layout" mandatory>
					<k-btn style="width:240px" small class="k-tight-btn k-nocaps-btn" light value="tree" @click.stop=""><k-icon small :color="lp_layout=='tree'?'white':'black'" class="mr-2">fas fa-arrows-up-down</k-icon>Vertical (Repository)</k-btn>
					<k-btn light value="map" small class="k-tight-btn k-nocaps-btn" @click.stop=""><k-icon small :color="lp_layout=='map'?'white':'black'" class="mr-2">fas fa-arrows-left-right</k-icon>Horizontal (Scope & Sequence)</k-btn>
				</k-btn-toggle>
			</div>
			<k-spacer/>
		</div>
		<div v-show="lp_layout=='map'&&additional_my_options_showing" class="mt-4">
			<div class="mx-3 pb-2 pt-1 px-2" style="background-color:#fff; border-radius:8px;"><k-checkbox class="mt-0" :label="'Arrange units by Terms'" v-model="use_terms" hide-details></k-checkbox></div>
			<div v-if="!use_terms" class="mt-4 mx-3"><k-text-field  background-color="#fff" hide-details outlined label="Label for unit scope & sequence (e.g. “Curriculum Map”)" v-model="unit_collection_title"></k-text-field></div>
			<div v-if="use_terms" class="d-flex align-center mt-4 mb-3">
				<h3 class="ml-3">{{terms_section_title}}</h3>
				<div v-if="terms_units_totals_mismatch" class="flex-grow-1 text-center">
					<div class="k-lp-editor-terms-mismatch-warning">
						<k-icon x-small color="amber lighten-2" class="mr-1">fas fa-triangle-exclamation</k-icon>
						Terms total {{terms_units_totals_mismatch.terms_total}} week{{terms_units_totals_mismatch.terms_total != 1 ? 's' : ''}}, units total {{terms_units_totals_mismatch.units_total}} week{{terms_units_totals_mismatch.units_total != 1 ? 's' : ''}}
					</div>
				</div>
				<k-spacer v-else/>
				<div v-if="block_editing_available" class="mr-3">
					<k-btn-toggle dense active-class="k-toggle-btn-active-class blue darken-4" class="k-toggle-btn" v-model="edit_term_mode" mandatory>
						<k-btn small class="k-tight-btn k-nocaps-btn" light value="normal">Edit Yearlong</k-btn>
						<k-btn small class="k-tight-btn k-nocaps-btn" light value="block">Edit Block</k-btn>
					</k-btn-toggle>
				</div>
			</div>
			<div v-if="use_terms" class="d-flex flex-wrap justify-left">
				<div v-for="(term, i) in terms" :key="i" class="k-lp-editor-term elevation-3">
					<k-tooltip v-if="learning_progression.block_values_customized(term)" top>
						<template v-slot:activator="{on}">
							<k-btn
								v-on="on"
								color="amber darken-3"
								class="k-lp-editor-block-badge"
								icon
								x-small
								@click="learning_progression.reset_block_values(term)"
							>
								<k-icon small>fas fa-circle-exclamation</k-icon>
							</k-btn>
						</template>
						Block values have been manually customized for this term — click to reset to default
					</k-tooltip>
					<div class="d-flex align-center">
						<k-text-field
							v-model="term[edit_term_mode == 'block' ? 'block_title' : 'title']"
							:label="edit_term_mode == 'block' ? 'Term (e.g. “Block 1”)' : 'Term (e.g. “Quarter 1”)'"
							:placeholder="edit_term_mode == 'block' ? learning_progression.default_block_title(term) : ''"
							background-color="#fff"
							color=""
							style="font-weight: bold"
							hide-details
							outlined
							@change="term_title_changed(term)"
						/>
						<k-text-field
							v-model="term[edit_term_mode == 'block' ? 'block_duration' : 'duration']"
							:placeholder="edit_term_mode == 'block' ? '' + learning_progression.term_default_block_weeks(term, terms, units) : ''"
							background-color="#fff"
							class="ml-1"
							label="Weeks"
							style="max-width: 100px"
							hide-details
							outlined
						/>
						<k-btn icon x-small color="red lighten-2" class="ml-2" style="margin-right:-3px" @click="delete_term(term)"><k-icon>fas fa-times-circle</k-icon></k-btn>
					</div>
				</div>
				<k-spacer/>
				<div class="mt-4 text-center" style="width:100%">
					<k-btn color="#666" width="300" dark @click="create_new_term">Create New Term</k-btn>
				</div>
			</div>
		</div>
	</div>

	<div class="k-lp-editor-units">
		<div class="d-flex align-center">
			<h3 class="ml-3">Units: <span style="font-size:0.8em;font-weight:normal;">(top-level “sub-collections”)</span></h3>
			<k-spacer/>
			<k-checkbox v-if="additional_my_options_showing" class="mt-0 mr-8" :label="'Specify unit numbers (e.g. “Unit 1”, “Unit 2”, etc.)'" v-model="use_unit_numbers" hide-details></k-checkbox>
			<k-checkbox v-if="additional_my_options_showing" class="mt-0 mr-3" :label="'Specify unit time intervals (weeks)'" v-model="use_unit_intervals" hide-details></k-checkbox>
		</div>
		<div>
			<draggable class="d-flex flex-wrap justify-left" v-bind="drag_options" v-model="units">
				<div v-for="(unit, _) in units" class="k-lp-editor-unit elevation-2" :style="units.length==1?'width:50%':''">
					<k-tooltip v-if="learning_progression.block_values_customized(unit)" top>
						<template v-slot:activator="{on}">
							<k-btn
								v-on="on"
								color="amber darken-3"
								class="k-lp-editor-block-badge"
								icon
								x-small
								@click="learning_progression.reset_block_values(unit)"
							>
								<k-icon small>fas fa-circle-exclamation</k-icon>
							</k-btn>
						</template>
						Block weeks have been manually customized for this unit — click to reset to default
					</k-tooltip>
					<div class="d-flex align-center">
						<div class="mr-3"><k-icon small color="#999" class="moveHandle">fas fa-arrows-alt</k-icon></div>
						<div style="flex:1 1 auto">
							<div v-if="use_unit_numbers||use_unit_intervals" class="d-flex mb-3 flex-fill">
								<k-text-field v-if="use_unit_numbers" background-color="#fff" hide-details outlined style="font-weight:bold" label="Number (e.g. “Unit 1”)" v-model="unit.display_number" @change="unit_number_changed(unit)"></k-text-field>
								<k-text-field
									v-if="use_unit_intervals"
									v-model="unit[block_editing_available && edit_term_mode == 'block' ? 'block_duration' : 'duration']"
									:placeholder="block_editing_available && edit_term_mode == 'block' ? '' + (unit.duration / 2) : ''"
									background-color="#fff"
									class="mx-1"
									label="Weeks"
									style="max-width: 100px"
									hide-details
									outlined
								/>
							</div>
							<k-text-field background-color="#fff" hide-details outlined :label="units.length==1?'Unit Title (optional for a single-unit collection)':'Unit Title'" v-model="unit.title"></k-text-field>
						</div>
						<div v-show="units.length>1" class="ml-3" style="flex:0 0 20px">
							<k-btn icon x-small color="red lighten-2" @click="delete_unit(unit)"><k-icon>fas fa-times-circle</k-icon></k-btn><br>
						</div>
					</div>
				</div>
			</draggable>
			<k-spacer/>

			<div class="mt-4 text-center" style="width:100%">
				<k-btn color="#666" dark width="280" class="mx-1" @click="create_new_unit">Create New Unit</k-btn>
				<!-- only show the "create units from standard" btn for cglt operators -->
				<k-btn v-if="collection_type=='course' && user_info.email.includes('commongoodlt')" color="#666" dark class="mx-1 k-tight-btn" @click="create_new_unit_from_standard">Create Unit from Standard (CGLT only)</k-btn>
			</div>

			<!-- e.g. https://apsources.commongoodlt.com -->
			<div v-if="user_info.email.includes('commongoodlt')" class="mt-4 d-flex"><k-spacer/><div style="flex:0 0 350px"><k-text-field dense background-color="#fff" hide-details outlined label="Sparkl origin override (CGLT only)" v-model="sparkl_origin_override"></k-text-field></div><k-spacer/></div>
		</div>
	</div>

</div>
</k-card-text>
</k-card>

</k-dialog></div></template>

<script>
import { mapState, mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import ColorPicker from '../utilities/ColorPicker.vue'
import ImportFromCASEMixin from './ImportFromCASEMixin'
import CollectionPlanEdit from './CollectionPlanEdit'
// import FroalaWrapper from '../froala/FroalaWrapper'

export default {
	components: { draggable, ColorPicker, CollectionPlanEdit },
	mixins: [ImportFromCASEMixin],
	props: {
		learning_progression: { type: Object, required: true },
	},
	data() { return {
		dialog_open: true,
		import_terms_showing: false,
		title: this.learning_progression.title,
		lp_layout: this.learning_progression.lp_layout,
		updated_at: this.learning_progression.updated_at,
		course_code: this.learning_progression.course_code,
		subject_case_identifier: this.learning_progression.subject_case_identifier,
		course_case_identifier: this.learning_progression.course_case_identifier,
		description: this.learning_progression.description,
		grade_low: this.learning_progression.grade_low,
		grade_high: this.learning_progression.grade_high,
		subject: this.learning_progression.subject,
		color: this.learning_progression.color,
		active: (this.learning_progression.active == 'yes'),
		subscription_only: this.learning_progression.subscription_only,
		subscription_code: this.learning_progression.subscription_code,
		repo_category: this.learning_progression.repo_category,
		terms: [],	// copied below
		units: [],	// copied below
		use_terms: this.learning_progression.use_terms,
		edit_term_mode: 'normal',
		use_unit_numbers: this.learning_progression.use_unit_numbers,
		use_unit_intervals: this.learning_progression.use_unit_intervals,
		unit_collection_title: this.learning_progression.unit_collection_title,
		sparkl_origin_override: this.learning_progression.sparkl_origin_override,
		resource_collection_ids: this.learning_progression.resource_collection_ids.concat([]),
		collection_plan: this.learning_progression.course_plan ? new Collection_Plan(this.learning_progression.course_plan) : null,

		state_course_code: 'unset',

		additional_my_options_showing: false,

		changing_subject_case_title: false,

		import_warning_shown: false,
		import_terms_data: '',

		unit_deletion_confirmed: false,

		initial_values: '',
		initial_subject: '',

		drag_options: {
		    animation: 200,
		    handle: '.moveHandle',
		},

		is_new_lp: false,
		new_categories: [],
	}},
	computed: {
		...mapState(['user_info', 'frameworks_loaded', 'framework_records', 'all_courses_loaded', 'all_courses', 'user_info', 'site_config']),
		...mapGetters(['use_term_mode']),
		// note that you can't change collection_type in the editor (but you can do this in the admin tool)
		collection_type() { return this.learning_progression.collection_type },
		is_repo_or_pd() { return this.collection_type == 'repo' || this.collection_type == 'pd' },
		is_my() {return this.collection_type == 'my'},
		is_repo() { return this.collection_type == 'repo'},
		dialog_title() {
			let s = this.is_new_lp ? 'New ' : 'Edit '
			if (this.collection_type == 'course') return s + 'Course Content Collection'
			if (this.collection_type == 'repo') return s + 'Resource Repository'
			if (this.collection_type == 'pd') return s + 'PD Content Collection'
			return s + 'Content Collection'	// 'my'/default
		},
		grades() {
			let arr = []
			for (let grade of this.$store.state.grades) {
				let text
				if (grade == 'K') text = 'Kindergarten'
				else if (!isNaN(grade*1)) text = 'Grade ' + grade
				else text = grade

				arr.push({ value: grade, text: text})
			}
			return arr
		},
		grades_low() {
			return [{value:'', text:'GRADE RANGE START'}].concat(this.grades)
		},
		grades_high() {
			return [{value:'', text:'GRADE RANGE END'}].concat(this.grades)
		},
		subjects() {
			let arr = []
			for (let subject in this.$store.state.subjects) {
				arr.push({ value: subject, text: subject})
			}
			arr.push({value: '', text: 'No subject chosen'})
			return arr
		},
		subject_frameworks() {
			let arr = []
			for (let subject in this.$store.state.subjects) {
				arr.push({ value: this.$store.state.subjects[subject].framework_identifier, text: subject})
				// console.log(subject)
				// add alt_frameworks if there
				if (this.$store.state.subjects[subject].alt_frameworks) {
					for (let alt_framework_title in this.$store.state.subjects[subject].alt_frameworks) {
						arr.push({ value: this.$store.state.subjects[subject].alt_frameworks[alt_framework_title], text: alt_framework_title})
					}
				}
			}
			for (const [guid, name] of Object.entries(this.$store.state.site_config.case_framework_options_for_collections)) {
				arr.push({ value: guid, text: name})
			}
			arr.push({value: 'none', text: 'None (don’t show course standards for this framework)'})
			return arr
		},
		subject_framework_record() {
			return this.framework_records.find(x=>x.lsdoc_identifier == this.subject_case_identifier)
		},
		subject_case_title() {
			if (this.subject_case_identifier == 'none') return 'No course standards'

			if (this.subject_framework_record) return this.subject_framework_record.json.CFDocument.title
			else return this.subject_case_identifier
		},
		course_case_title() {
			if (!this.course_case_identifier || this.subject_case_identifier == 'none') return ''

			if (this.subject_framework_record) {
				if (!this.subject_framework_record.framework_json_loaded) {
					this.$store.dispatch('get_lsdoc', this.subject_framework_record.lsdoc_identifier)
					return 'Loading…'
				} else if (this.subject_framework_record.json.CFItems) {
					let i = this.subject_framework_record.json.CFItems.find(x=>x.identifier == this.course_case_identifier)
					if (i) {
						return U.generate_cfassociation_node_uri_title(i, true)
					}
				}
			}
			// if we get to here, return the identifier
			return this.course_case_identifier
		},
		// color_select() { return this.$store.state.color_select },
		repo_dropdown() {
			// get list of all categories from courses
			let repo_cats = new Set()
			if (this.is_my) {
				repo_cats = new Set(
					Object.values(this.user_info.my_lps)
					.map(lp => lp.category)
					.filter(category => category && category.split('_')[1] !== '')
				);
			} else {
				for (let lp of this.all_courses) {
					if (!lp.repo_category || !lp.repo_category.split('_')[1]) continue
					if (this.is_repo_or_pd && (lp.collection_type == 'repo' || lp.collection_type == 'pd')) repo_cats.add(lp.repo_category)
				}
			}
			repo_cats = [...repo_cats]
			// sort the cats
			repo_cats.sort(U.natural_sort)

			// build array for drop-down, with value (including the sequence number) and text (not including the sequence number)
			let arr = []
			for (let rc of repo_cats) {
				// PW: seems like rc.split('_')[1] would work just as well...
				arr.push({value: rc, text: rc.split('_').slice(1).join('_')})
			}

			for (let nc of this.new_categories) {
				arr.push({value: nc, text: nc.split('_').slice(1).join('_')})
			}

			arr.push({value: 'x', text: '-- CREATE A NEW CATEGORY --'})

			return arr
		},
		published_asset_counts() {
			let counts = {published: 0, unpublished: 0}
			if (!this.learning_progression.agency_sanctioned) return counts

			this.learning_progression.units.forEach(unit => {
				unit.lessons.forEach(x => {
					if (!x.agency_sanctioned) {
						counts.unpublished++
					} else {
						counts.published++
					}
				})

				unit.resources.forEach(x => {
					if (!x.agency_sanctioned) {
						counts.unpublished++
					} else {
						counts.published++
					}
				})
			})
			
			return counts
		},

		// show options for "Collection_Plan" if...
		collection_plan_showing() {
			// this is a course collection
			if (this.collection_type != 'course') return false
			// and site_config.course_plans_enabled is 'yes'
			if (this.site_config.course_plans_enabled != 'yes') return false
			return true
		},

		// show the Yearlong/Block editing toggle only when terms are in use and the district distinguishes block vs. traditional scheduling
		block_editing_available() {
			return this.use_terms && this.use_term_mode
		},

		terms_section_title() {
			if (!this.block_editing_available) return 'Terms:'
			return (this.edit_term_mode == 'block' ? 'Block' : 'Yearlong') + ' Terms:'
		},

		// warns when the terms' total weeks and the units' total weeks don't add up to the same thing, for whichever mode is currently being edited
		terms_units_totals_mismatch() {
			if (!this.use_terms) return null
			if (!this.learning_progression.term_unit_totals_mismatched(this.terms, this.units, this.edit_term_mode)) return null
			return {
				terms_total: this.learning_progression.terms_total_weeks(this.terms, this.units, this.edit_term_mode),
				units_total: this.learning_progression.units_total_weeks(this.units, this.edit_term_mode),
			}
		},
	},
	mounted() {
		// the options that are optional for 'my' collections should always show for other types
		if (this.collection_type != 'my') this.additional_my_options_showing = true

		this.is_new_lp = empty(this.learning_progression.title)

		this.initial_values = JSON.stringify(this.learning_progression.copy_for_save())

		// create a copy of the lp to get a copy of of terms, units
		let lp_copy = new Learning_Progression(this.learning_progression)
		this.terms = lp_copy.terms
		this.units = lp_copy.units

		// get frameworks list if not already loaded -- but we don't have to wait for it to load
		if (!this.frameworks_loaded) this.$store.dispatch('get_lsdoc_list')

		// get all courses if not already loaded -- but we don't have to wait for it to load
		if (!this.all_courses_loaded) this.$store.dispatch('get_all_courses')

		// for courses
		if (this.collection_type == 'course') {
			// on creation, make sure the description in the collection_plan is in sync with the text of the unit -- i.e., make sure the same text is in both places (we'll normalize if/when we save)
			this.collection_plan.transfer_description_from_parent(this, 'description', true)	// by default we use what's in the collection description
			this.collection_plan.transfer_description_to_parent(this, 'description', true)
			// and make sure that markdown in the collection_plan is rendered, so that we can edit it with froala
			this.collection_plan.render_cpc_text_markdown()
		}

		// this used by the standards chooser hide_fn
		vapp.course_editor = this

		if (this.is_my) {
			if (this.learning_progression.lp_id in this.user_info.my_lps) this.repo_category = this.user_info.my_lps[this.learning_progression.lp_id].category
		}
	},
	methods: {
		editor_config(text, inline) {
			return U.get_froala_config({
				placeholderText: text,
				zIndex: 1000,
				// initOnClick: true,
				toolbarInline: (inline === true),
				paragraphFormat: {
					H3: 'Section Header',
					N: 'Normal',
					BLOCKQUOTE: 'Block Quote',
				    PRE: 'Code',
				},
			})
		},

		choose_course_case_identifier() {
			let data = {}
			if (this.subject_case_identifier != 'none') data.framework_identifier = this.subject_case_identifier

			// set hide_fn to hide the standards chooser if/when the editor is no longer visible
			let show_data = { hide_fn: ()=>{ return ($(vapp.course_editor?.$el).is(':visible') == false) } }

			vapp.$refs.satchel.execute('show', show_data).then(()=>{
				vapp.$refs.satchel.execute('load_framework', data).then(()=>{
					vapp.$refs.satchel.execute('chooser', {chooser_mode: true}).then((aligned_item) => {
						// if for some reason the user chose a different framework, save it as the subject_case_identifier
						if (aligned_item.framework_identifier != this.subject_case_identifier) {
							this.subject_case_identifier = aligned_item.framework_identifier
						}
						this.course_case_identifier = aligned_item.cfitem.identifier

						// hide the chooser, because we only choose one item here
						vapp.$refs.satchel.execute('hide')

						// save immediately, unless this is a new lesson -- currently not doing this because when you save it always closes the editor
						// if (!empty(this.learning_progression.course_code)) this.save_edits()
					})
				})
			})
		},

		clear_course_case_identifier () {
			this.course_case_identifier = ''
		},

		repo_category_changed() {
			if (this.repo_category === 'x') {
				this.$prompt({
					title: 'Create a New Category',
					text: 'Enter category name:',
					initialValue: '',
					disableForEmptyValue: true,
					acceptText: 'Create Category',
					acceptIconAfter: 'fas fa-arrow-right',
				}).then(cat_name => {
					// MC: it doesn't matter what number the number is before the category name, as long as it is greater than the current amount of items in the repo_categories since it will go to the very end;
					//     when the user reorders the categories, the category name will fix itself
					//	   998 reserved for uncategorized collections
					cat_name = '998_' + cat_name
					this.new_categories.push(cat_name)
					this.repo_category = cat_name
				}).catch(n=>{this.repo_category = ""}).finally(f=>{})
			}
		},

		title_changed() {
			// not doing the below as of 12/29/2023, because it fouls some things up
			return

			if (empty(this.title)) return

			// try to extract grade and subject from title if not already set
			if (empty(this.grade_low)) {
				if (this.title.search(/KK/i) > -1) {
					this.grade_low = 'K'
					this.grade_high = 'K'
				} else if (this.title.search(/(\d+)/i) > -1) {
					let grade = RegExp.$1 * 1
					if (grade >= 1 && grade <= 12) {
						this.grade_low = grade+''
						this.grade_high = grade+''
					}
				}
			}

			if (empty(this.subject)) {
				for (let subject in this.$store.state.subjects) {
					if (this.title.search(new RegExp(subject)) > -1) {
						this.subject = subject
						break
					}
				}
			}
		},

		grade_low_changed() {
			if (empty(this.grade_high) || U.grade_value(this.grade_high) < U.grade_value(this.grade_low)) {
				this.grade_high = this.grade_low
			}
		},

		grade_high_changed() {
			if (empty(this.grade_low) || U.grade_value(this.grade_low) > U.grade_value(this.grade_high)) {
				this.grade_low = this.grade_high
			}
		},

		subject_changed() {
			let ss = this.$store.state.subjects
			// if subject is chosen/changed...
			if (!empty(ss[this.subject])) {
				// if subject_case_identifier wasn't originally entered or is currently empty, or if it equals the value for the original subject,
				if ((empty(this.subject_case_identifier) || this.subject_case_identifier == 'none') 
					|| empty(this.learning_progression.subject) 
					|| (ss[this.learning_progression.subject] && this.learning_progression.subject_case_identifier == ss[this.learning_progression.subject].framework_identifier)) {
					// enter the value for the new subject
					this.subject_case_identifier = ss[this.subject].framework_identifier
				}
			}
		},

		create_new_term() {
			this.terms.push({
				title: '',
				duration: '',
				block_duration: '',
				block_title: '',
			})
		},

		delete_term(term) {
			// if we get to here just delete the term after confirming
			this.$confirm({
				text: 'Are you sure you want to delete this term?',
				acceptText: 'Delete Term',
			}).then(y => {
				this.terms.splice(this.terms.findIndex(x=>x==term), 1)
			}).catch(n=>{}).finally(f=>{});
		},

		term_title_changed(term) {
			// if user enters just a number, change to "Quarter #" (or "Block #" when editing the block title)
			let field = this.edit_term_mode == 'block' ? 'block_title' : 'title'
			if (!empty(term[field]) && !isNaN(term[field] * 1)) {
				term[field] = (this.edit_term_mode == 'block' ? 'Block ' : 'Quarter ') + term[field]
			}
		},

		create_new_unit_from_standard(start_identifier) {
			let data = { framework_identifier: '', item_identifier: '' }
			if (!empty(this.subject_case_identifier)) data.framework_identifier = this.subject_case_identifier
			if (typeof(start_identifier) == 'string') data.item_identifier = start_identifier
			else if (!empty(this.course_case_identifier)) data.item_identifier = this.course_case_identifier

			let show_data = { 
				// set embed_hide_callback_fn to toggle aligning_to_standards off when the user closes the chooser
				embed_hide_callback_fn: ()=>{ this.aligning_to_standards = false },
				// set hide_fn to hide the standards chooser if/when the editor is no longer visible
				hide_fn: ()=>{ return ($(vapp.course_editor?.$el).is(':visible') == false) },
			}

			vapp.$refs.satchel.execute('show', show_data).then(()=>{
				vapp.$refs.satchel.execute('load_framework', data).then(()=>{
					vapp.$refs.satchel.execute('chooser', {chooser_mode: true}).then((o) => {
						// prompt to ask user if they want to prefix the unit title with anything, and if they want to set the unit standards
						let note = o.cfitem.humanCodingScheme ? `<br><br><i style="font-size:14px">Note: the human readable code (${o.cfitem.humanCodingScheme}) will be used as the “Unit Number”.</i>` : ''
						let initial_title = o.cfitem.fullStatement
						if (!empty(this.create_new_unit_from_standard_prefix)) initial_title = this.create_new_unit_from_standard_prefix + initial_title
						this.$prompt({
							title: 'Title',
							text: `Enter the unit title:${note}`,
							secondaryCheckbox: 'Align the new unit to this standard and its children',
							secondaryCheckboxInitiallyOn: true,
							initialValue: initial_title,
							disableForEmptyValue: true,
							acceptText: 'Create Unit',
							hideCancel: false,	// set to true to hide the cancel button
						}).then(arr => {
							let title = $.trim(arr[0])
							let escaped_full_statement = o.cfitem.fullStatement.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
							let re = new RegExp('^(.+)' + escaped_full_statement)
							if (title.search(re) > -1) this.create_new_unit_from_standard_prefix = RegExp.$1
							else this.create_new_unit_from_standard_prefix = ''

							let u = new LP_Unit({title: title})
							if (o.cfitem.humanCodingScheme) u.display_number = o.cfitem.humanCodingScheme
							// if user clicked box to save associated standards, save them too
							if (arr[1]) {
								// this only works if they choose an item from the collection's framework -- we have the full json loaded for this framework
								let framework_record = this.framework_records.find(x=>x.lsdoc_identifier == o.framework_identifier)
								if (!framework_record) {
									this.$alert('This only works if you choose a standard from the collection’s subject framework.')
									return
								}
								u.standards = [new CASE_Item(o)]
								this.add_child_standards(u, framework_record, o.cfitem.identifier)
							}
							console.warn('creating unit from standard', u)
							this.units.push(u)

							// re-call this fn so the author can add another unit if they want
							this.create_new_unit_from_standard(o.cfitem.identifier)

						}).catch(n=>{console.log(n)}).finally(f=>{})
						// vapp.$refs.satchel.execute('hide')
					})
				})
			}).catch(()=>{ vapp.$refs.satchel.execute('hide') })	// this will execute when the standards are hidden
		},

		// recursive fn to store descendent standards
		add_child_standards(unit, framework_record, parent_identifier) {
			// look for all children of the parent -- isChildOf assocs where the destination is the parent_identifier
			let assocs = framework_record.json.CFAssociations.filter(o => o.associationType == 'isChildOf' && o.destinationNodeURI.identifier == parent_identifier)
			for (let assoc of assocs) {
				let item = framework_record.json.CFItems.find(x=>x.identifier == assoc.originNodeURI.identifier)
				if (empty(item)) {
					console.error(`couldn’t find child item ${assoc.originNodeURI.identifier}`)
					continue	// shouldn't happen
				}
				// add the child item
				let o = {
					cfitem: item,
					framework_identifier: framework_record.lsdoc_identifier,
					childOf: parent_identifier,
					sequenceNumber: assoc.sequenceNumber ?? 0,
				}
				unit.standards.push(new CASE_Item(o))

				// recurse to add grandchildren
				this.add_child_standards(unit, framework_record, item.identifier)
			}
		},

		create_new_unit() {
			let u = new LP_Unit()

			// if this is a course collection and we have site_config.default_folders_for_course_units, create default folders for the unit
			if (this.collection_type == 'course' && !empty(this.$store.state.site_config.default_folders_for_course_units)) {
				let create_folders = (o, parent_folder_id) => {
					for (let key in o) {
						let val = o[key]
						let f = u.create_resource_folder({title:val.title, parent_folder_id:parent_folder_id, color:val.color, cross_unit_key:val.cross_unit_key})
						if (val.children) {
							create_folders(val.children, f.folder_id)
						}
					}
				}
				create_folders(this.$store.state.site_config.default_folders_for_course_units, 'top')
			}

			// remove duration value so label shows in input
			u.duration = ''
			this.units.push(u)
		},

		delete_unit(unit) {
			if (this.unit_deletion_confirmed) {
				this.units.splice(this.units.findIndex(x=>x==unit), 1)

			} else {
				this.$confirm({
					text: 'Are you sure you want to delete this unit? (Note: you will not be asked to confirm subsequent unit deletions.)',
					acceptText: 'Delete Unit',
				}).then(y => {
					this.units.splice(this.units.findIndex(x=>x==unit), 1)
					// don't ask again
					this.unit_deletion_confirmed = true
				}).catch(n=>{}).finally(f=>{});
			}
		},

		// Drag is implemented
		// move_unit(unit, direction) {
		// 	let i = this.units.findIndex(x=>x==unit)

		// 	if (direction == 'up') {
		// 		if (i > 0) {
		// 			this.units.splice(i, 1)
		// 			this.units.splice(i-1, 0, unit)
		// 		}
		// 	} else {
		// 		if (i < this.units.length - 1) {
		// 			this.units.splice(i, 1)
		// 			this.units.splice(i+1, 0, unit)
		// 		}
		// 	}
		// },

		unit_number_changed(unit) {
			// if user enters just a number, change to "Unit #"
			if (!empty(unit.display_number) && !isNaN(unit.display_number*1)) {
				console.log('here: ' + unit.display_number)
				unit.display_number = 'Unit ' + unit.display_number
			}
		},

		clear_resource_collection(index) {
			// clear the last resource_collection_ids value
			this.resource_collection_ids.splice(index, 1)
		},

		save_edits(course_code_confirmed) {
			// trim values
			this.title = $.trim(this.title)
			this.course_code = $.trim(this.course_code)
			this.description = U.froala_trim_text(this.description)

			if (this.units.length > 1) {
				for (let i = 0; i < this.units.length; i++) {
					if (empty(this.units[i].title)) {
						this.$alert('Each unit must must have a title.')
						return false
					}
				}
			}

			if (empty(this.title)) {
				this.$alert('The content collection must have a title.')
				return false
			}

			if (this.collection_type == 'course' && empty(this.course_code)) {
				this.$alert('You must enter a course code.')
				return false
			}

			// 01.23 - 1130.123456
			// if this is a new lp, or the course_code has changed, check to make sure the course_code doesn't already exist
			let is_new_lp = false
			if (empty(this.learning_progression.course_code) || this.learning_progression.course_code != this.course_code) {	// note that this is checking the course_code sent in via props, not what the user entered
				is_new_lp = true

				let e = this.$store.state.all_courses.find(o=>o.course_code==this.course_code)
				if (e) {
					this.$alert(sr('A Course for this course code ($1) already exists (the Course is titled “$2”).', e.course_code, e.title))
					return false
				}
			}

			// if we made it through the above check, and the course code existed and has changed, ask if they're sure they want to do this
			if (!empty(this.learning_progression.course_code) && this.course_code != this.learning_progression.course_code && course_code_confirmed !== true) {
				this.$confirm({
				    title: 'Are you sure?',
				    text: 'Are you sure you want to change the Course Code? Only do this if you know what you’re doing!',
				    acceptText: 'I’m Sure',
				}).then(y => {
					this.save_edits(true)
				}).catch(n=>{console.log(n)}).finally(f=>{})

				return false
			}

			if (this.collection_type == 'course' && (empty(this.grade_low) || empty(this.grade_high))) {
				this.$alert('For Course collections, you must set the start and end of the grade range (the minimum and maximum grade levels can be equal).')
				return false
			}

			if (this.collection_type == 'course' && empty(this.subject)) {
				this.$alert('For Course collections, you must set the subject area.')
				return false
			}

			// if subscription_only is true and we don't have a subscription_code, call service to get a code
			if (this.subscription_only && empty(this.subscription_code)) {
				// call service here...
				this.$store.dispatch('generate_subscription_code', this.learning_progression.lp_id).then(res => {
					// in `then`, set subscription_code and re-call save_edits
					this.subscription_code = res.subscription_code
					this.updated_at = res.updated_at
					this.save_edits()
				})
				return
			}

			// validate term/unit week values
			// for (let term of this.terms) {
			// 	if (isNaN(term.duration*1)) {
			// 		this.$alert('You must enter a numeric value for “Weeks” for all terms. (Note that “0” <i>is</i> a valid entry.)')
			// 		return false
			// 	}
			// }
			// for (let unit of this.units) {
			// 	if (isNaN(unit.duration*1)) {
			// 		this.$alert('You must enter a numeric value for “Weeks” for all units. (Note that “0” <i>is</i> a valid entry.)')
			// 		return false
			// 	}
			// }

			// for course collections (other types don't currently have collection_plans...
			if (this.collection_type == 'course') {
				// the collection's description should be in either the course_plan or description, not both
				// so if the unit_plan is set, clear description; otherwise clear the collection_plan description
				if (this.collection_plan?.is_set()) {
					this.description = ''
				} else {
					this.collection_plan?.clear_description()
				}
				this.$store.commit('set', [this.learning_progression, 'course_plan', this.collection_plan])
			}

			this.$store.commit('set', [this.learning_progression, 'title', this.title])
			this.$store.commit('set', [this.learning_progression, 'lp_layout', this.lp_layout])
			this.$store.commit('set', [this.learning_progression, 'updated_at', this.updated_at])
			this.$store.commit('set', [this.learning_progression, 'course_code', this.course_code])
			this.$store.commit('set', [this.learning_progression, 'description', this.description])
			this.$store.commit('set', [this.learning_progression, 'subject_case_identifier', this.subject_case_identifier])
			this.$store.commit('set', [this.learning_progression, 'course_case_identifier', this.course_case_identifier])
			this.$store.commit('set', [this.learning_progression, 'grade_low', this.grade_low])
			this.$store.commit('set', [this.learning_progression, 'grade_high', this.grade_high])
			this.$store.commit('set', [this.learning_progression, 'subject', this.subject]) // probably don't need this since it is in the watcher
			this.$store.commit('set', [this.learning_progression, 'color', this.color])
			this.$store.commit('set', [this.learning_progression, 'terms', this.terms])
			this.$store.commit('set', [this.learning_progression, 'units', this.units])
			this.$store.commit('set', [this.learning_progression, 'use_terms', this.use_terms])
			this.$store.commit('set', [this.learning_progression, 'use_unit_numbers', this.use_unit_numbers])
			this.$store.commit('set', [this.learning_progression, 'use_unit_intervals', this.use_unit_intervals])
			this.$store.commit('set', [this.learning_progression, 'unit_collection_title', this.unit_collection_title])
			this.$store.commit('set', [this.learning_progression, 'sparkl_origin_override', this.sparkl_origin_override])
			this.$store.commit('set', [this.learning_progression, 'resource_collection_ids', this.resource_collection_ids])
			this.$store.commit('set', [this.learning_progression, 'active', this.active ? 'yes' : 'no'])
			this.$store.commit('set', [this.learning_progression, 'subscription_code', this.subscription_code])
			this.$store.commit('set', [this.learning_progression, 'subscription_only', this.subscription_only])
			this.$store.commit('set', [this.learning_progression, 'repo_category', this.repo_category])

			// only set state_course_code if it's set -- we use an advanced editor for this
			if (this.state_course_code != 'unset') {
				this.$store.commit('set', [this.learning_progression, 'state_course_code', this.state_course_code])
			}

			if (JSON.stringify(this.learning_progression.copy_for_save()) != this.initial_values) {
				const repo_category = this.repo_category
				if (this.is_my) this.$store.commit('set', [this.learning_progression, 'repo_category', ''])
				this.$store.dispatch('save_learning_progression', this.learning_progression).then((res)=>{
					// note that store will update anything needed in this.learning_progression
					// if course code changed, have to refresh to the new collection
					if (course_code_confirmed === true) {
						document.location.pathname = this.learning_progression.vue_route()
					} else {
						// if is_new_lp, add to all courses
						if (is_new_lp) {
							this.$store.commit('add_to_array', [this.all_courses, this.learning_progression])
						}
						this.cancel_editor()
						this.$router.push(this.learning_progression.vue_route())
					}

					// set collection.full_description_height to -1 so that the description resizer re-runs
					this.$store.commit('set', [this.learning_progression, 'full_description_height', -1])

					// for my collections, save the my_lps structure separately, since it goes in the user table
					if (this.is_my) {
						let lps = this.user_info.my_lps
						lps[res.lp_id] = {
							// if there is a sequence of -1, push to end,
							sequence: -1,
							// MC: temporarily set to 999 for is_my, probably better than the way sequence is handled in ResourceRepositoriesIndex.vue (reduces code)
							category: repo_category ? repo_category : '999_'
						}
						const payload = {
							user_id: this.user_info.user_id,
							lps: lps,
						}
						U.ajax('save_user_my_lps', payload, result => {
							if (result.status != 'ok') console.error('cannot save')
							else this.$store.commit('set', [this.user_info, 'my_lps', lps])
						})
					}
				})
			} else {
				console.log('nothing changed, so not saving')
				this.cancel_editor()
			}
			// return true to signal that the save was able to proceed
			return true
		},


		cancel_editor(edit_action) {
			this.$nextTick(()=>this.$emit('editor_cancel'))
		},

		import_terms_btn_clicked() {
			// prompt for file to import
			this.$prompt({
				text: '<p>Open the Curriculum Map document in Microsoft Word, choose “Save As” from the File menu, then save the document in “Web Page, filtered (.htm)” format. Then use the file upload interface below to find and process the .htm file you just saved:</p>',
				promptType: 'file',
				acceptText: 'Process File',
				cancelText: 'Cancel'
			}).then(file => {
				if (file.type != 'text/html') {
					this.$alert('You must save the file in “Web Page, filtered (.htm)” format, which will result in a file that ends in “.htm” or “.html” The file you attempted to process doesn’t have the right extension.').then(()=>this.import_terms_btn_clicked())
					return
				}

				let reader = new FileReader()
				reader.onload = e => {
					this.process_lp_html(e.target.result)
				}
				reader.readAsText(file)

			}).catch(n=>{console.log(n)}).finally(f=>{})
		},

		process_lp_find_next_unit(units, param) {
			// find the next unit whose param is empty or 0
			for (let unit of units) {
				if (empty(unit[param]) || unit[param] === 0) return unit
			}
			return null
		},

		process_lp_html(html) {
			let report = ''
			let has_errors = false

			// get the html and find the "WordSection1" node
			let nodes = $.parseHTML(html)
			let jq = $(nodes)
			// for (let node of nodes) {
			// 	jq = $(node)
			// 	if (jq.hasClass('WordSection1')) break
			// }

			if (empty(jq)) { this.show_lp_import_error(1, report); return; }

			let terms = []
			let units = []

			function add_to_report(s, level) {
				console.log(s)

				// tags
				s = s.replace(/</g, '&lt;')

				// if line starts with **, mark as possible error
				if (s.indexOf('**') == 0) {
					s = s.replace(/^(\*\*.*)/, '<b style="color:red">$1</b>')
					has_errors = true
				}

				// indentation
				for (let li = 0; li < level; ++li) {
					s = '  ' + s
				}

				report += s + '<br>'
			}

			// document may have multiple tables...
			let tables = jq.find('table')
			add_to_report(sr('Found $1 tables',tables.length), 0)
			for (let ti = 0; ti < tables.length; ++ti) {
				add_to_report('Processing table #' + (ti+1), 0)
				// look for rows in the table
				let rows = $(tables[ti]).find('tr')
				if (empty(rows) || rows.length == 0) {
					add_to_report('*** No rows in table #' + ti, 1)
					continue
				}

				// go through each row of the table...
				let last_row = ''
				let terms_repeat = false
				for (let r = 0; r < rows.length; ++r) {
					let row = $(rows[r])
					let rt = $.trim(row.text()).toLowerCase()

					// if we find a row that starts with 'quarter/semester/term', that row should specify the terms
					if (rt.search(/(quarter|semester|term)/) == 0 && last_row == '') {
						add_to_report('')
						add_to_report('found terms...', 1)
						last_row = 'terms'

						for (let td of row.find('td')) {
							let $td = $(td)
							let term_title = $.trim($td.text().replace(/\s+/g, ' '))

							if (empty(term_title)) {
								add_to_report('*** Empty td in term row', 2)
							} else {
								// if the first term_title we find matches the first term_title we have in terms,
								// assume that this is a "repeat table" that just includes additional text
								if (terms.length > 0 && term_title == terms[0].title) {
									terms_repeat = true
									add_to_report('*** Assuming this table includes repeated terms from previous table')
									break
								}

								terms.push({
									title: term_title,
									duration: '9',	// assume 9 weeks
								})
								add_to_report('term: ' + terms[terms.length-1].title, 2)
							}
						}

						continue	// done with the row
					}

					// if we find a row that starts with 'unit' after the 'terms' row (or before we process any row -- we may have "term-less units"),
					// this row should specify the unit numbers, which we store as the "title"
					if (rt.search(/(unit)/) == 0 && (last_row == 'terms' || last_row == '')) {
						add_to_report('')
						add_to_report('found units...', 1)
						last_row = 'units'

						if (terms_repeat == true) {
							add_to_report('*** Assuming this table includes repeated units from previous table')
							continue
						}

						// go through each unit's td
						for (let td of row.find('td')) {
							let title = $.trim($(td).text().replace(/\s+/g, ' '))
							if (empty(title)) {
								add_to_report('*** Empty td in unit title row', 2)
							} else {
								let unit = new LP_Unit({title: title})
								units.push(unit)
								add_to_report('unit: ' + unit.display_number, 2)
							}
						}

						continue	// done with the row
					}

					// if we find a row that includes the word 'week' right after the 'units' row, this row should specify the unit durations, which we store as "duration"
					if (rt.search(/(week)/) > -1 && last_row == 'units') {
						add_to_report('')
						add_to_report('found durations...', 1)
						last_row = 'durations'

						if (terms_repeat == true) {
							add_to_report('*** Assuming this table includes repeated units from previous table')
							continue
						}

						// go through each unit's td
						for (let td of row.find('td')) {
							let duration_text = $.trim($(td).text().replace(/\s+/g, ' ')).toLowerCase()
							if (empty(duration_text)) {
								add_to_report('*** Empty td in unit duration row', 2)
							} else {
								let duration = duration_text.replace(/([\d.]+) week(s)?/i, '$1')*1
								if (isNaN(duration)) {
									add_to_report('*** Bad unit duration found: ' + $(td).text(), 2)
									duration = 1
								}

								// find the next unit to fill in
								let unit = this.process_lp_find_next_unit(units, 'duration')
								if (empty(unit)) {
									add_to_report('*** More unit durations found than units -- possible error')
									continue
								}

								unit.duration = duration
								add_to_report(sr('unit “$1” duration: $2', unit.display_number, unit.duration), 2)
							}
						}

						continue	// done with the row
					}

					// the row right after durations should specify the unit “titles”, which we store as 'description'
					if (last_row == 'durations') {
						add_to_report('')
						add_to_report('found descriptions...', 1)
						last_row = 'descriptions'

						if (terms_repeat == true) {
							add_to_report('*** Assuming this table includes repeated units from previous table')
							continue
						}

						// go through each unit's td
						for (let td of row.find('td')) {
							// TODO: do we need to worry about preserving html here? hopefully not
							let description = $.trim($(td).text().replace(/\s+/g, ' '))
							if (empty(description)) {
								add_to_report('*** Empty td in unit description row', 2)
							} else {
								// find the next unit to fill in
								let unit = this.process_lp_find_next_unit(units, 'description')
								if (empty(unit)) {
									add_to_report('*** More unit titles found than units -- possible error')
									continue
								}
								unit.title = description
								add_to_report(sr('unit “$1” description: $2', unit.display_number, unit.title), 2)
							}
						}

						continue	// done with the row
					}

					// the row right after descriptions should be the unit text
					if (last_row == 'descriptions') {
						add_to_report('')
						add_to_report('found unit text...', 1)
						last_row = 'text'

						// go through each unit's td
						let ui = -1
						for (let td of row.find('td')) {
							++ui
							let text_text = $.trim($(td).text().replace(/\s+/g, ' '))
							if (empty(text_text)) {
								add_to_report('*** Empty td in unit text row', 2)
							} else {
								// find the next unit to fill in
								let unit
								if (terms_repeat) {
									unit = units[ui]
								} else {
									unit = this.process_lp_find_next_unit(units, 'text')
								}

								if (empty(unit)) {
									add_to_report('*** More unit text columns found than units -- possible error')
									continue
								}

								// clean contents...
								$(td).find('*').each(function(i, el) {
									let tag = $(el).prop('tagName')
									let html = $(el).html()
									html = html.replace(/\&nbsp;/g, ' ')
									html = html.replace(/style=".*?"/g, '')
									html = html.replace(/<(\/)?span\b.*?>/g, '')
									$(el).replaceWith(sr('<$1>$2</$3>', tag, $.trim(html), tag))
								})
								let text = $(td).html().replace(/<p>(\s)*<\/p>/g, '')	// remove blank lines
								text = text.replace(/\s+/g, ' ')	// consolidate spaces
								text = $.trim(text)

								unit.text += text
								add_to_report(sr('unit “$1” text: $2…', unit.display_number, unit.text.substr(0, 20)), 2)
							}
						}

						break	// once we do this row, we're done processing
					}
				}
				add_to_report('')
			}

			// clear units that have no title, duration, or description
			for (let i = 0; i < units.length; ++i) {
				if (units[i].display_number == '' && units[i].duration == 0 && units[i].title == '') {
					units.splice(i, 1)
					--i
				}
			}

			// if we have existing unit ids, reuse them
			for (let i = 0; i < this.learning_progression.units.length; ++i) {
				if (this.learning_progression.units[i].lp_unit_id != 0) {
					units[i].lp_unit_id = this.learning_progression.units[i].lp_unit_id
				}
			}

			add_to_report('DONE!')
			console.log(terms, units)

			if (terms.length > 0 || units.length > 0) {
				this.terms = terms
				this.units = units
				let msg = sr('Imported $1 terms and $2 units. After closing this dialog, click “Save” at the bottom of the page to save the imported terms and units, or “Cancel” to cancel the import and revert to any previously-saved terms and units.', terms.length, units.length)
				if (has_errors) {
					msg += '<br><br><b style="color:red">Note:</b> Possible errors were found in the import process; see Import Report.'
				}
				this.$confirm({
				    title: 'File Processed',
				    text: msg,
				    acceptText: 'Done',
				    cancelText: 'View Import Report',
					dialogMaxWidth: 600
				}).then(y => {
				}).catch(n=>{
					report = sr('<pre>$1</pre>', report)
					this.$alert({title: 'Import Processing Report', text: report, dialogMaxWidth:800})
				}).finally(f=>{})

				this.import_terms_showing = false
			} else {
				this.$alert('No terms or units imported. Sorry!!')
			}
		},

		show_lp_import_error(errnum, report) {
			report = sr('<pre>$1</pre>', report)
			this.$alert({title: sr('Error parsing file ($1)', errnum), text: report, dialogMaxWidth:800})
		},

		import_cc_btn_clicked() {
			// prompt for file to import
			this.$prompt({
				text: '<p>Extract the Thin Common Cartridge to produce a single XML file. Then use the file upload interface below to find and process the XML file:</p>',
				promptType: 'file',
				acceptText: 'Process XML File',
				cancelText: 'Cancel'
			}).then(file => {
				console.log(file)
				if (file.type != 'text/xml') {
					this.$alert('You must upload an XML file (.xml). The file you attempted to process doesn’t have the right extension.').then(()=>this.import_cc_btn_clicked())
					return
				}

				let reader = new FileReader()
				reader.onload = e => {
					this.process_cc_xml(e.target.result)
				}
				reader.readAsText(file)

			}).catch(n=>{console.log(n)}).finally(f=>{})
		},

		process_cc_xml(xml) {
			let $xml = $($.parseXML(xml))
			// window.$xml = $xml

			////////////////////////////////////////////////////////
			function get_text_from_child_tags(node, arr, obj, key) {
				let child_node = node
				// search down for the tag_names given in arr
				for (let tag_name of arr) {
					child_node = child_node.getElementsByTagName(tag_name)
					if (child_node.length > 0) {
						child_node = child_node[0]
					} else {
						break
					}
				}
				// if we don't find the child_node, do nothing
				if (empty(child_node) || empty(child_node.textContent)) {
					return ''
				}

				// if obj is 'text', return the trimmed content
				if (obj == 'text') return $.trim(child_node.textContent)

				// if obj is 'node', return the node
				if (obj == 'node') return child_node

				// else we should have received obj/key; set key to the trimmed content
				if (!empty(obj)) {
					obj[key] = $.trim(child_node.textContent)
				}
			}

			////////////////////////////////////////////////////////
			function get_toc_item(item_node, level, path) {
				if (empty(item_node.children)) return null

				// if item has a path attribute, add to path
				let item_path = item_node.getAttribute('path')
				if (!empty(item_path)) path = `${path}/${item_path}`

				let o = {}
				for (let x = 0; x < item_node.children.length; ++x) {
					let child_node = item_node.children[x]

					// extract title
					if (child_node.tagName == 'title') o.t = $.trim(child_node.textContent)

					// get child items
					if (child_node.tagName == 'item') {
						let child = get_toc_item(child_node, level + 1, path)
						if (!empty(child)) {
							if (empty(o.c)) o.c = []
							o.c.push(child)
						}
					}

					// if the item has metadata,...
					if (child_node.tagName == 'metadata') {
						// then if we have an identifierref, set up to process the metadata
						let identifierref = item_node.getAttribute('identifierref')
						if (!empty(identifierref)) {
							o.r = identifierref

							// we do this so that a) we know what resource_ids are in the tree, and b) we can transfer "teacher-facing" values to the nodes after processing the resources (??)
							if (!resource_ids[identifierref]) {
								resource_ids[identifierref] = []
							}
							resource_ids[identifierref].push(o)
						}
					}

					// note that the item will likely have either child items *or* a resource; but handle the case where we have both??
				}

				// if the item has an identifierref and we didn't set up a resource above (because we found metadata), set up a resource now
				let identifierref = item_node.getAttribute('identifierref')
				if (!empty(identifierref) && !o.r) {
					o.r = identifierref

					// if path is not empty, set it
					if (!empty(path)) o.path_start = path

					// we do this so that we know what resource_ids are in the tree
					if (!resource_ids[identifierref]) {
						resource_ids[identifierref] = []
					}
					resource_ids[identifierref].push(o)
				}

				// if we didn't get a title or children, return null (not sure if this would happen...)
				if (empty(o.t) && empty(o.c)) return null

				// if we did get children, store the identifier of the item as 'f'; we use these to mark "folders" of items to include for certain units
				if (!empty(o.c)) {
					o.f = item_node.getAttribute('identifier')
				}

				// hack for hmh-physical-science-from-safari: if `path` includes '_TE', it's teacher-facing
				if (path.includes('_TE')) {
					o.i = 1
				}

				return o
			}

			////////////////////////////////////////////////////////
			let parse_resource = (resource_node, identifier) => {
				// note that we use the identifierref from the CC file as the resource_id; if the tcc file is re-uploaded, old resources will be overwritten (which is what we want)
				let resource_json = {
					// note that we store the title in 'description', and the description in 'long_description'
					resource_id: identifier,
					shareable: true,
				}

				// we should always have resource_ids[identifier], because we only call parse_resource if resource_ids[identifier] is nonempty
				// I can't remember why we store this as an array, but we do
				let resource_json_from_manifest = resource_ids[identifier][0]

				// if we got the description in resource_json_from_manifest, save it (the description might or might not be in the resource item too; if it is we'll overwrite with what is there)
				if (!empty(resource_json_from_manifest.t)) {
					resource_json.description = resource_json_from_manifest.t
				}
				// ditto for teacher-facing flag
				if (resource_json_from_manifest.i == 1) {
					resource_json.teacher_facing = true
				}

				// if we have a resource_type set, use it
				if (!empty(resource_type)) {
					resource_json.type = resource_type
					if (resource_type == 'cc_file') {
						// get url from href, stripping out the initial path
						let url = resource_node.getAttribute('href').replace(/^.*?\//, '')

						// for the stupid things saved with urls that go back to safari...
						if (url.includes('partner.safarimontage.com')) {
							// find the pdf file in the resource and get its url instead, extracting just the filename
							let farr = $(resource_node).find('file')
							for (let fi of farr) {
								let href = fi.getAttribute('href')
								if (href.search(/.*\/(.*\.pdf)/) > -1) {
									url = RegExp.$1
									break
								}
							}
							console.warn(`partner: ${identifier} / ${url}`)

							// replace the 'Unit.*' string of the path with 'pdfs'
							resource_json_from_manifest.path_start = resource_json_from_manifest.path_start.replace(/Unit.*/, 'pdfs')
						}
						
						// set url to start with filepath_start, then delete it
						if (empty(resource_json_from_manifest.path_start)) {
							console.warn('no path_start: ' + identifier)
						} else {
							url = `${resource_collection_resource_id}${resource_json_from_manifest.path_start}/${url}`
							console.log(`${identifier}: ${url}`)
						}
						// save the resource url, then delete path_start from resource_json_from_manifest
						resource_json.url = url
						delete resource_json_from_manifest.path_start
					}

				// otherwise assume this is a thin CC and use type 'lti'
				} else {
					resource_json.type = 'lti'
					resource_json.lti_params = {}
				}

				// look for the title and long_description
				get_text_from_child_tags(resource_node, ['lticc:cartridge_basiclti_link', 'blti:title'], resource_json, 'description')
				get_text_from_child_tags(resource_node, ['lticc:cartridge_basiclti_link', 'blti:description'], resource_json, 'long_description')

				// get other values from the $resource...
				// lti endpoint and  from the $resource
				get_text_from_child_tags(resource_node, ['lticc:cartridge_basiclti_link', 'blti:secure_launch_url'], resource_json.lti_params, 'endpoint')

				// role (learner or instructor); need to search through nodes for this...
				let ed_nodes_parent = get_text_from_child_tags(resource_node, ['metadata', 'lomr:lom', 'lomr:educational'], 'node')
				if (!empty(ed_nodes_parent) && ed_nodes_parent.children.length > 0) {
					let ed_nodes = ed_nodes_parent.getElementsByTagName('lomr:intendedEndUserRole')
					for (let ed_node of ed_nodes) {
						if (get_text_from_child_tags(ed_node, ['lomr:source'], 'text') == 'IMSGLC_CC_Rolesv1p2') {
							// look for role in metadata / lomr:lom / lomr:educational / lomr:intendedenduserrole
							// where lomr:source is 'IMSGLC_CC_Rolesv1p2';
							// if that node's lomr:value is 'Instructor', it's teacher-facing; otherwise assume student-facing
							let role = get_text_from_child_tags(ed_node, ['lomr:value'], 'text')
							resource_json.teacher_facing = ((''+role).toLowerCase() == 'instructor')

							// if teacher-facing, store "i:1" ('i' meaning 'instructor') in o (i.e. in the resource_collection_json)
							// if (resource_json.teacher_facing) o.i = 1
						}
					}
				}

				// lti custom tags: there may be multiple of these, so get the node, and if it exists and has children...
				let custom_node = get_text_from_child_tags(resource_node, ['lticc:cartridge_basiclti_link', 'blti:custom'], 'node')
				if (!empty(custom_node) && custom_node.children.length > 0) {
					for (let custom_prop_node of custom_node.children) {
						// check that the child is called 'lticm:property', and extract the name attribute and text
						if (custom_prop_node.tagName == 'lticm:property') {
							let prop_name = 'custom_' + custom_prop_node.getAttribute('name')
							resource_json.lti_params[prop_name] = $.trim(custom_prop_node.textContent)
						}
					}
				}

				// CASE standards: there may be multiple of these, so get the node, and if it exists and has children...
				// new (2025) cc's don't have 'csm:'
				let standard_nodes_parent = get_text_from_child_tags(resource_node, ['metadata', 'csm:curriculumStandardsMetadataSet', 'csm:curriculumStandardsMetadata', 'csm:setOfGUIDs'], 'node')
				if (empty(standard_nodes_parent)) standard_nodes_parent = get_text_from_child_tags(resource_node, ['metadata', 'curriculumStandardsMetadataSet', 'curriculumStandardsMetadata', 'setOfGUIDs'], 'node')
				if (!empty(standard_nodes_parent) && standard_nodes_parent.children.length > 0) {
					// each child should have structure `<labelledGUID><label>xxx</label><GUID>yyy</GUID></labelledGUID>`
					for (let standard_node of standard_nodes_parent.children) {
						// check that the child is called 'labelledGUID', and extract the text of the GUID tag
						if (standard_node.tagName.includes('labelledGUID')) {
							// push case_identifier into array in resource_json
							let case_identifier = get_text_from_child_tags(standard_node, ['csm:GUID'], 'text')
							if (empty(case_identifier)) case_identifier = get_text_from_child_tags(standard_node, ['GUID'], 'text')

							if (!this.subject_framework_record?.cfitems) {
								if (!this.subject_framework_record_warning) {
									this.$inform('Note: CASE GUIDs found in the cartridge, but we don’t have a subject_framework_record, so we can’t save these alignments.')
									this.subject_framework_record_warning = true
								}
							} else {
								// look for the case item in this.subject_framework_record
								let cfi = this.subject_framework_record.cfitems[case_identifier]
								
								// if not initially found, look in sourceItemIdentifier
								if (!cfi) cfi = this.subject_framework_record.json.CFItems?.find(x=>x.extensions?.sourceItemIdentifier == case_identifier)

								if (cfi) {
									if (empty(resource_json.standards)) resource_json.standards = []
									resource_json.standards.push(new CASE_Item({cfitem:cfi, framework_identifier: this.subject_framework_record.lsdoc_identifier}))
								} else {
									console.log(`couldn’t find item for ${case_identifier}`)
								}
							}
						}
					}
				}

				// use the Resource class/copy_for_save to make sure we get the data in the right format
				return new Resource(resource_json).copy_for_save()
			}

			////////////////////////////////////////////////////////

			// try to find the root toc item in the cc $xml
			let toc_item = $xml.find('organization[structure="rooted-hierarchy"] item[identifier=root]')
			if (toc_item.length != 1) {
				this.$alert(sr('The Thin Common Cartridge file could not be processed (error 483:)', toc_item.length))
				return
			}

			// if we have a resourcetype attribute (CGLT would have set this to, e.g., `cc_file`), note it
			let resource_type = toc_item.attr('resourcetype')

			// look for an identifier in the manifest, to use as the resource_id of the "collection resource"; if not found use a uuid
			let resource_collection_resource_id = $xml.find('manifest').attr('identifier')
			if (empty(resource_collection_resource_id)) resource_collection_resource_id = U.new_uuid()

			let resource_collection_json
			let resource_ids = {}
			let resources = []
			// extract toc tree and resources. we have to delay starting the process a bit to allow the loading indicator/message to appear
			U.loading_start('Processing Common Cartridge file; this may take some time...')
			setTimeout(()=>{
				// first we extract the tree using this recursive fn
				resource_collection_json = get_toc_item(toc_item[0], 0, '')

				// get the resources and go through them one by one
				let teacher_count = 0, student_count = 0
				let $resources = $xml.find('resources')
				for (let resource_node of $resources[0].childNodes) {
					// skip text nodes
					if (resource_node.nodeType == resource_node.TEXT_NODE) {
						if (!empty($.trim(resource_node.textContent))) {
							console.warn(`non-empty text node in resources: '${resource_node.textContent}'`)
						}
						continue
					}

					let identifier = resource_node.getAttribute('identifier')

					// check to make sure this is one of the resource_ids we need to get
					if (resource_ids[identifier]) {
						// console.log('parse_resource')
						let resource = parse_resource(resource_node, identifier)
						resources.push(resource)

						// if teacher-facing, store "i:1" ('i' meaning 'instructor') in all nodes for this resource (i.e. in the resource_collection_json)
						if (resource.teacher_facing) for (let node of resource_ids[identifier]) {
							node.i = 1
							++teacher_count
						} else {
							++student_count
						}

						// delete from resource_ids, so that when we finish getting all resources we can tell if we're missing anything
						delete resource_ids[identifier]

					} else {
						console.warn('found resource that wasn’t in tree: ' + identifier)
					}
				}
				
				for (let identifier in resource_ids) {
					console.warn('didn’t find resource for identifier: ' + identifier)
				}

				console.log(`found ${teacher_count} teacher-facing and ${student_count} student-facing`)
				console.log(resource_collection_json)
				console.log(resources)

				// U.download_json_file(resource_collection_json, 'TCC-TREE-' + this.learning_progression.title)
				// U.download_json_file(resources, 'TCC-RESOURCES-' + this.learning_progression.title)

				U.loading_stop()

				// tell the user what happened...
				let msg = sr('Found $1 resources (see browser debugger to inspect data). To save the resources in the system and link them to this Curriculum Map, enter a title for the resource collection (e.g. “Science 3rd Grade HMH Resources”) and click “Save”.', resources.length)
				this.$prompt({
				    title: 'Processing Successful',
				    text: msg,
				    acceptText: 'Save',
				}).then(resource_collection_title => {
					if (empty(resource_collection_title)) return

					// finally save the resources
					let payload = {
						resource_collection_resource_id: resource_collection_resource_id,
						resource_collection_title: resource_collection_title,
						resource_collection_json: resource_collection_json,
						resources: resources
					}
					this.$store.dispatch('save_resource_collection', payload).then((resource_collection_resource_id)=>{
						// when save is complete...
						// push the resource collection's resource_id onto resource_collection_ids, unless it already exists (in which case we just re-processed the TCC)
						if (!this.resource_collection_ids.find(o=>o==resource_collection_resource_id)) {
							this.resource_collection_ids.push(resource_collection_resource_id)
						}
						// then save the LP; by sending true we'll refresh the window after saving
						this.save_edits(true)
					})

				}).catch(n=>{console.log(n)}).finally(f=>{})
			}, 50)
		},
		update_color(new_color) {
			this.color = new_color
		},

		// Collection shows UnpublishAllDialog, which lets the user choose the new status and confirm
		unpublish_all() {
			this.$emit('unpublish_all')
		},

		register_sparkls_to_cureum() {
			// call a service that registers all sparkl activities for this collection to the current cureum instance 
			// (as long as the activities aren't already registered to a *different* cureum instance)
			this.$confirm({
			    title: 'Are you sure?',
			    text: 'This action will register all Sparkl activities in this collection to the current Cureum instance, so that the activities cannot be edited from other Cureum instances.'
					+ '<div class="mt-3">Are you sure you want to proceed?</div>',
			    acceptText: 'Proceed',
				dialogMaxWidth: 600
			}).then(() => {
				let payload = {
					user_id: this.user_info.user_id,
					lp_id: this.learning_progression.lp_id
				}
				U.loading_start()
				U.ajax('register_sparkls_to_cureum', payload, result => {
					U.loading_stop()
					if (result.status != 'ok') {
						this.$alert('AJAX error (see console)')
					} else if (result.activities_registered == 0) {
						this.$alert(`The collection does not appear to include any Sparkl activities.`)
					} else {
						console.warn('actions from sparkl', result.actions)
						this.$alert(`Attempted to register ${result.activities_registered} activity(s); see console for results.`)
					}
				})

			}).catch(n => {console.error(n)})
		},

		async update_state_course_code() {
			let initial_value
			if (this.state_course_code == 'unset') {
				initial_value = this.learning_progression.state_course_code
			} else {
				initial_value = this.state_course_code
			}

			let state_course_code = await U.prompt_promise({
				title: 'Set State Course Code',
				text: `Enter the State Course Code to use for this course collection, for use when launching ${this.site_config.course_alt_cureum_btn_text}. (If no State Course Code is entered, ${this.site_config.app_name} will try to use this course collection’s “local” Course Code: ${this.course_code}.)`,
				initialValue: initial_value,
				disableForEmptyValue: true,
				acceptText: 'Set State Course Code',
				dialogMaxWidth: 640,
			})
			if (!state_course_code) return

			// if user entered a value (including empty string), set this.state_course_code
			this.state_course_code = $.trim(state_course_code)
		},
	}
}
</script>

<style lang="scss">
.k-collection-editor-dialog {
	max-height: calc(100vh - 16px) !important;
}
.k-lp-editor-wrapper {
	clear: both;
	// margin:10px;
	// padding-top:15px;
	font-size: 16px;
	h3 { padding-left: 0!important; }

	.k-lp-editor-top-data {
		background-color: $v-amber-lighten-5;	// :#f08c78;
		padding: 15px;
		margin: 15px 0;
		border-radius: 4px;
	}

	.k-lp-grade-menu {
		max-width: 180px;
	}

	.k-lp-subject-menu {
		max-width: 300px;
	}

	.k-lp-color-swatch {
		width: 30px;
		height: 30px;
		background-color: #999;
		align-self: center;
		margin-left: 5px;
		border-radius: 8px;
	}

	.k-lp-editor-terms {
		background-color: $v-light-blue-lighten-5;
		padding: 10px 0 15px 0;
		border-radius: 8px;
	}

	.k-lp-editor-term {
		position: relative;
		background-color: $v-amber-lighten-5;  // :#92c3e9;
		padding: 12px;
		flex: 1 1 320px;
		min-width: 310px;
		max-width: calc(33.333% - 20px);
		margin: 10px;
		border-radius: 4px;
	}

	.k-lp-editor-block-badge {
		position: absolute;
		top: 0;
		right: 8px;
		transform: translateY(-50%);
		background-color: #fff;
		border-radius: 50%;
		padding: 2px;
	}

	.k-lp-editor-terms-mismatch-warning {
		display: inline-flex;
		align-items: center;
		font-size: 13px;
		line-height: 1.2;
		color: $v-amber-lighten-2;
		background-color: #555;
		padding: 2px 12px;
		border-radius: 999px;
	}

	.k-lp-editor-units {
		margin-top: 20px;
		background-color: $v-purple-lighten-5;
		padding: 10px 0 15px 0;
		border-radius: 8px;
	}

	.k-lp-editor-unit {
		position: relative;
		padding: 10px;
		border: 4px solid transparent;
		width: calc(33% - 20px);
		margin: 10px;
		border-radius: 4px;
		background-color: $v-amber-lighten-5; 	// :#f8cdad;
	}

	.k-lp-editor-resources-header {
		font-size: 14px;
		font-weight: bold;
		color: #666;
	}

	.k-lp-editor-standard-resource {
		padding: 10px;
		margin: 8px 0;
		border-radius: 4px;
		background-color: #eee;
	}

	.k-lp-editor-standard-description {
		flex: 1 1 auto;
		cursor: pointer;
		overflow: hidden;
		white-space: nowrap;
	}

	.k-lp-editor-standard-text {
		margin-top: 8px;
		padding-top: 8px;
		border-top: 1px solid #ccc;
	}

	.k-lp-editor-resource-creator {
		background-color: #eee;
		margin-top: 10px;
		padding: 10px;
		border-radius: 4px;
	}

	.k-lp-editor-term-importer {
		background-color: #f8cdad;
		padding: 15px;
		margin-top: 15px;
		border-radius: 4px;
	}

	.k-lp-editor-import-box textarea {
		font-size: 12px;
		line-height: 16px!important;
	}

	.k-lp-editor-description textarea {
		font-size: 14px;
		line-height: 18px!important;
	}
}

.k-collection-description-froala-wrapper-wrapper {
	.fr-view table td, .fr-view table th {
		padding: 4px;
		border: 0;
	}
}

.k-v-align {
	margin: auto 0;
}
</style>
